import React, { useState } from 'react';
import { ImageBackground, View } from 'react-native';
import { ActivityIndicator, Colors } from 'react-native-paper';
import { useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { Header } from '../../../components/common';
import { AppButton } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import styles from './styles';

const AlterPic = ({ navigation }) => {
  const { studentData } = useSelector((state) => state.student);
  const [loading, setLoading] = useState(false);

  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <Header navigation={navigation} userName={studentData.nome} />
      <View style={styles.content}>
        {loading ? (<ActivityIndicator color="#FFF" size={pixelDimensions(7)} />) : (
          <>
            {/* <Image source={trainerData.foto} style={styles.imageChangePicBigger} />
            <AppButton size="bold" label="ALTERAR FOTO DE PERFIL" labelStyle={styles.textButtonAlterPic} onPress={submitAvatar} style={styles.buttonAlterPic} /> */}
            <AppButton size="bold" label="FINANCEIRO" labelStyle={styles.textButtonAlterPic} onPress={() => navigation.navigate('Student Finance')} style={styles.buttonAlterPic} />
            <AppButton size="bold" label="ALTERAR SENHA" labelStyle={styles.textButtonAlterPic} onPress={() => navigation.navigate('Student Alter Password')} style={styles.buttonAlterPic} />
          </>
        )}
      </View>
      <AppButton size="bold" label="VOLTAR" rippleColor={Colors.indigo700} style={styles.buttonBack} labelStyle={styles.textBack} onPress={() => navigation.goBack()} />
    </ImageBackground>
  );
};

export default AlterPic;
